// Operator-picker decisions for the Config page. The label states the operator's real CR
// quoting state (settings `cr_quote_enabled:<op>`), NEVER the config file's ACTIVE flag —
// ACTIVE only means "included in the Avinode batch / broker fan-out", and the CR-drain
// operators are ACTIVE=false by design.

/** Label text for one operator button, or '' when the state is unknown. */
export function quotingLabel(op) {
  if (!op) return '';
  if (op.quoting_paused === true) return 'Paused';
  if (op.cr_quote_enabled === true) return 'Quoting ON';
  if (op.cr_quote_enabled === false) return 'Quoting OFF';
  return '';
}

/** Default selection: first operator with CR quoting ON, else the first operator. */
export function defaultOperatorId(operators) {
  const list = Array.isArray(operators) ? operators : [];
  return (list.find(o => o && o.cr_quote_enabled === true) || list[0])?.operator_id;
}
